<template>
  <div class="topography">
    <div v-for="(row, index) in jsonData" :key="row.id" class="row">
      <div class="row-title">
        <div>
          {{row.title}}
        </div>
      </div>
      <div class="main">
        <div v-for="col in row.colItem" :key="col.id" class="col" :style="colStyle(row.colItem)">
          <el-popover
            placement="bottom"
            width="600"
            trigger="click">
            <el-table :data="[col]" border style="width: 100%;" v-if="index === 0">
              <el-table-column prop="quantity" header-align="center" align="center" label="数量" width="60">
              </el-table-column>
              <el-table-column prop="model" header-align="center" align="center" label="型号">
              </el-table-column>
              <el-table-column prop="redundant" header-align="center" align="center" label="是否冗余">
              </el-table-column>
              <el-table-column prop="edition" header-align="center" align="center" label="版本">
              </el-table-column>
              <el-table-column prop="address" header-align="center" align="center" label="地址">
              </el-table-column>
              <el-table-column prop="state" header-align="center" align="center" label="状态">
              </el-table-column>
            </el-table>
            <el-table :data="[col]" border style="width: 100%;" v-if="index === 1">
              <el-table-column prop="quantity" header-align="center" align="center" label="数量" width="60">
              </el-table-column>
              <el-table-column prop="type" header-align="center" align="center" label="类型">
              </el-table-column>
              <el-table-column prop="security" header-align="center" align="center" label="安全配置">
              </el-table-column>
              <el-table-column prop="out_port" header-align="center" align="center" label="对外通讯接口">
              </el-table-column>
              <el-table-column prop="boundary" header-align="center" align="center" label="边界防御设备">
              </el-table-column>
              <el-table-column prop="edition" header-align="center" align="center" label="版本">
              </el-table-column>
              <el-table-column prop="address" header-align="center" align="center" label="地址">
              </el-table-column>
              <el-table-column prop="state" header-align="center" align="center" label="状态">
              </el-table-column>
            </el-table>
            <el-table :data="[col]" border style="width: 100%;" v-if="index === 2">
              <el-table-column prop="quantity" header-align="center" align="center" label="数量" width="60">
              </el-table-column>
              <el-table-column prop="type" header-align="center" align="center" label="类型">
              </el-table-column>
              <el-table-column prop="edition" header-align="center" align="center" label="版本">
              </el-table-column>
              <el-table-column prop="address" header-align="center" align="center" label="地址">
              </el-table-column>
              <el-table-column prop="state" header-align="center" align="center" label="状态">
              </el-table-column>
            </el-table>
            <el-table :data="[col]" border style="width: 100%;" v-if="index === 3">
              <el-table-column prop="quantity" header-align="center" align="center" label="数量" width="60">
              </el-table-column>
              <el-table-column prop="model" header-align="center" align="center" label="型号">
              </el-table-column>
              <el-table-column prop="edition" header-align="center" align="center" label="版本">
              </el-table-column>
              <el-table-column prop="address" header-align="center" align="center" label="地址">
              </el-table-column>
              <el-table-column prop="state" header-align="center" align="center" label="状态">
              </el-table-column>
            </el-table>
            <el-table :data="[col]" border style="width: 100%;" v-if="index === 4">
              <el-table-column prop="quantity" header-align="center" align="center" label="数量" width="60">
              </el-table-column>
              <el-table-column prop="model" header-align="center" align="center" label="型号">
              </el-table-column>
              <el-table-column prop="edition" header-align="center" align="center" label="版本">
              </el-table-column>
              <el-table-column prop="address" header-align="center" align="center" label="地址">
              </el-table-column>
              <el-table-column prop="state" header-align="center" align="center" label="状态">
              </el-table-column>
            </el-table>
            <div slot="reference" @click="clickServer">
              <div class="imgs">
                <div v-for="(img,index) in col.imgs" :key="index" class="imgItem">
                  <div class="imgItemImg">
                    <img src="../../../../assets/img/server.png" name="server" class="icon-svg icon">
                  </div>
                </div>
              </div>
              <div class="title">型号：{{col.title}}</div>
              <div class="description">数量：{{col.description}}</div>
            </div>
          </el-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  props: {
    jsonData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    colStyle(colItem) {
      if (colItem && colItem.length) {
        return 'width: ' + (100 / colItem.length).toFixed(0) + '%'
      }
      return 'width: 100%'
    },
    clickServer() {
    }
  }
}
</script>

<style lang="scss" scoped>
.topography {
  padding: 0 20px;
  border-top: 1px solid;
  border-bottom: 1px solid;
  .row {
    width: 100%;
    border-top: 1px solid #cccccc;
    .row-title {
      font-size: 20px;
      padding: 20px;
      vertical-align: top;
      width: 20%;
      // min-width: 300px;
      // border-right: 1px solid #ccc;
      height: 100%;
      display: inline-block;
    }
    .main {
      width: 78%;
      height: 100%;
      display: inline-block;
      .col {
        display: inline-block;
        min-width: 200px;
        .imgs {
          cursor: pointer;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          .imgItem {
            flex: 1;
            width: 100px;
            height: 100px;
            min-width: 100px;
            .imgItemImg {
              width: 100px;
              height: 100px;
              text-align: center;
              margin: 0 auto;
              .icon {
                margin-top: 20px;
                font-size: 60px;
              }
            }
          }
        }
        .title {
          cursor: pointer;
          width: 100%;
          text-align: center;
          font-size: 16px;
        }
        .description {
          cursor: pointer;
          width: 100%;
          text-align: center;
          font-size: 16px;
        }
      }
    }
  }
}
.topography :first-child {
  border-top: none;
}
</style>